module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), (_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "container bg02 payroll"
  }, [_vm._m(0), (_vm.message) ? _c('p', {
    staticClass: "payroll__message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), (_vm.error) ? _c('p', {
    staticClass: "payroll__error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), (_vm.document) ? _c('div', {
    staticClass: "payroll__detail"
  }, [_c('div', {
    staticClass: "payroll__detail__head"
  }, [_vm._v(_vm._s(_vm.document.attributes['document-type-i18n']) + "　" + _vm._s(_vm.document.attributes['pay-date-format']))]), _c('table', [(_vm.document.attributes['sections']) ? _c('tbody', [_vm._l((_vm.document.attributes['sections']), function(section) {
    return [_c('tr', {
      staticClass: "payroll__section"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(section.label))])]), _vm._l((section.rows), function(row) {
      return _c('tr', [_c('th', [_vm._v(_vm._s(row.label))]), _c('td', {
        class: _vm.isAmountRow(row) ? 'text-right' : 'text-left'
      }, [_vm._v(_vm._s(_vm.formatValue(row)))])])
    })]
  })], 2) : _c('tbody', _vm._l((_vm.document.attributes['rows']), function(row) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(row.label))]), _c('td', {
      class: _vm.isAmountRow(row) ? 'text-right' : 'text-left'
    }, [_vm._v(_vm._s(_vm.formatValue(row)))])])
  }), 0)]), _c('div', {
    staticClass: "payroll__download"
  }, [(_vm.document.attributes['pdf-available']) ? _c('button', {
    staticClass: "btn01",
    class: _vm.downloading ? '-unavailable' : '',
    attrs: {
      "type": "button",
      "disabled": _vm.downloading
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.downloading ? '準備中...' : 'PDFをダウンロード'))])]) : _c('p', {
    staticClass: "fz12"
  }, [_vm._v("PDFがまだ生成されていません。")])])]) : _vm._e(), (_vm.documents.length === 0) ? _c('div', {
    staticClass: "payroll__empty"
  }, [_c('p', [_vm._v("表示できる明細はありません。")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("明細は支給日の前日から表示されます。")])]) : _vm._e(), _vm._l((_vm.documents), function(item, index) {
    return _c('div', {
      staticClass: "payroll__item"
    }, [_c('span', {
      staticClass: "payroll__type",
      class: item.attributes['document-type'] === 'bonus' ? '-bonus' : ''
    }, [_vm._v(_vm._s(item.attributes['document-type-i18n']))]), _c('p', {
      staticClass: "payroll__date"
    }, [_vm._v("支給日：" + _vm._s(item.attributes['pay-date-format']))]), _c('div', {
      staticClass: "payroll__button"
    }, [_c('button', {
      staticClass: "btn01",
      class: _vm.sendingId === item.id ? '-unavailable' : '',
      attrs: {
        "type": "button",
        "disabled": _vm.sendingId === item.id
      },
      on: {
        "click": function($event) {
          _vm.requestLink(item.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.sendingId === item.id ? '送信中...' : 'リンクをメールで受け取る'))])])])])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payroll__intro"
  }, [_c('h1', [_vm._v("給与・賞与明細")]), _c('p', {
    staticClass: "fz13 mt10"
  }, [_vm._v("明細を開くには、まず閲覧用リンクをメールでお送りします。")]), _c('p', {
    staticClass: "fz11 mt5"
  }, [_vm._v("（リンクは15分間のみ有効です）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64398854!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/payroll-list.pug
// module id = 1422
// module chunks = 1